import React from 'react';

type TabsProps<T extends string> = {
  tabs: readonly T[];
  activeTab: T;
  onTabChange: (tab: T) => void;
  labels?: Record<T, string>;
  tabSpacingInPixels?: number;
};

function Tabs<T extends string>({ tabs, activeTab, onTabChange, labels, tabSpacingInPixels = 16 }: TabsProps<T>) {
  
  return (
    <div className="tw-border-b tw-border-blue-950">
      <div className={`tw-flex`} style={{ gap: `${tabSpacingInPixels}px` }}>
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tw-py-2 tw-text-sm tw-text-blue-950 tw-transition-colors ${activeTab === tab
              ? 'tw-border-b-2 tw-border-blue-950 tw-font-semibold'
              : 'hover:tw-text-gray-700'
              }`}
            onClick={() => onTabChange(tab)}
            data-testid={`tab-${tab}`}
          >
            {labels?.[tab] || tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Tabs;